import { render, staticRenderFns } from "./application-info-tab.vue?vue&type=template&id=78f885e2"
import script from "./application-info-tab.vue?vue&type=script&lang=js"
export * from "./application-info-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports